import type { EventBlock } from '@src/library/models/events';
import * as st from './styles.module.scss';

interface Props {
  eventBlocks: EventBlock[];
}

export const EventBlocks = ({ eventBlocks }: Props): JSX.Element => {
  return (
    <>
      {eventBlocks.length &&
        eventBlocks.map((block) => (
          <div className={st.block} key={block.id}>
            <h3 className={st.block__title}>{block.title}</h3>
            <p className={st.block__subtitle}>{block.subtitle}</p>
            <div className={st.block__description}>
              {block.image && <img src={block.image} alt="" />}
              <p>{block.description}</p>
            </div>
          </div>
        ))}
    </>
  );
};
